import React, { PropsWithChildren } from "react";
import { Typography, Grid } from "@mui/material";

type StepLayoutProps = { title: string, description: React.ReactNode };

const StepLayout: React.FC<PropsWithChildren<StepLayoutProps>> =
({ title, description, children }) =>
  <Grid container spacing={2}>
    <Grid size={{ xs: 12 }}>
      <Typography variant="h5">{title}</Typography>
      <hr />
      {description}
    </Grid>
    {children}
  </Grid>;

export default StepLayout;
